import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(56,189,248,0.15),transparent_60%)]"></div>
      <div className="perspective-grid"></div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-semibold leading-[1.05] tracking-tight text-white">
          Scale your business
          <br />
          With <span className="text-white">AI-Driven</span>
          <br />
          Cloud Solutions<span className="text-amber-400 animate-pulse">|</span>
        </h1>

        <div className="mt-10 flex justify-center">
          <a href="#services">
            <button className="btn-gradient inline-flex items-center gap-2 rounded-full px-6 py-3 text-white text-sm font-medium">
              Explore Our Services
              <ArrowUpRight size={16} />
            </button>
          </a>
        </div>

        <p className="mt-8 text-slate-400 max-w-xl mx-auto text-sm md:text-base">
          Integrating cloud, software, automation, and infrastructure to optimize operations and support long-term growth.
        </p>
      </div>
    </section>
  );
};

export default Hero;
